<template>
    <div class="row">
        <div class="col-12 mb-1">
            <router-link
                :to="{ name: 'create-letter-content' }"
                class="btn btn-success float-right"
            >
                Create
            </router-link>
        </div>
    </div>
    <vue-good-table
        mode="remote"
        v-on:page-change="onPageChange"
        v-on:per-page-change="onPerPageChange"
        v-on:selected-rows-change="letterContentSelectionChanged"
        :totalRows="totalRecords"
        :columns="columns"
        :rows="rows"
        :pagination-options="{
            enabled: true,
        }"
        :search-options="{
            enabled: true,
            externalQuery: searchTerm
        }"
        :select-options="{
            enabled: true,
            disableSelectInfo: true,
            selectOnCheckboxOnly: true
        }"
    >
        <template #table-row="props">
            <span v-if="props.column.field === 'action'">
                <div class="d-flex align-items-center col-actions">
                    <router-link
                        class="mr-1 text-primary"
                        :to="
                            {
                                name: 'view-letter-content',
                                params: { letter_content: props.row.id }
                            }
                        "
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View Letter Content Detail"
                    >
                        <vue-feather type="eye"></vue-feather>
                    </router-link>
                    <router-link
                        class="mr-1 text-primary"
                        :to="
                            {
                                name: 'edit-letter-content',
                                params: { letter_content: props.row.id }
                            }
                        "
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Edit Letter Content"
                    >
                        <vue-feather type="edit"></vue-feather>
                    </router-link>
                    <a
                        class="mr-1 text-primary"
                        @click="deleteLetterContent(props.row.id)"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Delete Letter Content"
                    >
                        <vue-feather type="trash"></vue-feather>
                    </a>
                </div>
            </span>
        </template>
    </vue-good-table>
</template>
<style>

</style>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useSettingStore } from '../../stores/SettingStore.js'
    import { VueGoodTable } from 'vue-good-table-next';
    import Swal from 'sweetalert2'
    import moment from 'moment';
    export default {
        props: {
        },
        components: {
            VueGoodTable
        },
        mounted()
        {
            if (_.isNull(useSettingStore().setting)) {
                useSettingStore().fetchSetting();
            }
            else {
                this.getLetterContents();
            }
        },
        watch: {
            'settingStore.setting'(value) {
                if (value != null) {
                    this.getLetterContents();
                }
            },
        },
        setup()
        {
            return {
                settingStore: useSettingStore(),
                moment: moment,
                baseUrl: baseUrl
            }
        },
        data() {
            return {
                currentPage: 1,
                currentPerPage: 10,
                totalRecords: 0,
                columns: [
                    {
                        label: 'ID',
                        field: 'id',
                    },
                    {
                        label: 'CONTENT',
                        field: 'content',
                    },
                    {
                        label: 'Type',
                        field: 'type',
                    },
                    {
                        label: 'Create Date',
                        field: 'created_at',
                        formatFn: this.formatDate
                    },
                    {
                        label: 'Action',
                        field: 'action',
                    }
                ],
                rows: [],
                searchTerm: '',
            };
        },
        methods:{
            onPageChange(params) {
                this.currentPage = params.currentPage;
                this.getLetterContents();
            },
            onPerPageChange(params) {
                this.currentPerPage = params.currentPerPage;
                this.currentPage = 1;
                this.getLetterContents();
            },
            getLetterContents() {
                let $this = this;
                const route = this.$router.resolve({
                    name: "list-letter-content",
                }).href;
                console.log(route);
                axios.get(
                    route,{
                            currentPage: $this.currentPage,
                            currentPerPage: $this.currentPerPage
                        }
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.rows = response.data.data.rows
                    $this.totalRecords = response.data.data.totalRecords
                    return;
                }).catch(function(error) {
                    setTimeout(() => {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    }, 2000)
                });
            },
            letterContentSelectionChanged(params) {
            },
            deleteLetterContent(id) {
                let $this = this,
                props = $this.$router.resolve(
                    {
                        name: 'view-letter-content',
                        params: { letter_content: id }
                    }
                );
                Swal.fire({
                    title: 'Are you sure you want to delete letter content?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        axios.delete($this.baseUrl + props.path)
                        .then(function(response) {
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            $this.currentPage = 1;
                            $this.getLetterContents();
                            toastr.success(response.data.message, 'Success!');
                            return;
                        }).catch(function(error) {
                            toastr.error(error.response.data.response_msg, 'Error!');
                        });
                    }
                });
            },
            formatDate(date)
            {
                return this.moment(date).format('llll');
            }
        },
        computed: {
        }
    }
</script>
